import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { VehicleLocationDto } from '@fleet-beat/api';
import { AuthHeaders, BaseApiService, CoreInjectorTokens, Environment, ResponseDto } from '@fleet-beat/core';
import { Observable, catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TruckLocationApiService {
  private readonly baseUrl: string = `${this.environment.assetsApiUrl}/api/location`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}

  getLocation(vehicleId: string, auth: AuthHeaders): Observable<VehicleLocationDto> {
    return this.baseApiService.get(`${this.baseUrl}/${vehicleId}`, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<VehicleLocationDto>) => this.baseApiService.mapResponse(response)),
    );
  }
}
